import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
var _withScopeId = function (n) {
  return _pushScopeId("data-v-6c6abddc"), n = n(), _popScopeId(), n;
};
var _hoisted_1 = {
  class: "home-header-container"
};
var _hoisted_2 = {
  class: "inner-container"
};
var _hoisted_3 = /*#__PURE__*/_withScopeId(function () {
  /*#__PURE__*/return _createElementVNode("p", {
    height: 31,
    style: {
      "color": "#fff"
    }
  }, " 山东省青少年创意编程与智能设计大赛 ", -1);
});
var _hoisted_4 = /*#__PURE__*/_withScopeId(function () {
  /*#__PURE__*/return _createElementVNode("span", {
    class: "token-info"
  }, "活动信息", -1);
});
var _hoisted_5 = /*#__PURE__*/_createTextVNode("活动信息");
var _hoisted_6 = /*#__PURE__*/_createTextVNode("退出");
var _hoisted_7 = /*#__PURE__*/_createTextVNode("登录");
var _hoisted_8 = /*#__PURE__*/_createTextVNode("评审入口");
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  var _component_a_col = _resolveComponent("a-col");
  var _component_a_avatar = _resolveComponent("a-avatar");
  var _component_a_button = _resolveComponent("a-button");
  var _component_a_menu_item = _resolveComponent("a-menu-item");
  var _component_a_menu = _resolveComponent("a-menu");
  var _component_a_dropdown = _resolveComponent("a-dropdown");
  var _component_a_space = _resolveComponent("a-space");
  var _component_a_row = _resolveComponent("a-row");
  var _component_LoginDialog = _resolveComponent("LoginDialog");
  var _component_GoToEnvCheckDialog = _resolveComponent("GoToEnvCheckDialog");
  return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createVNode(_component_a_row, {
    type: "flex",
    justify: "space-between",
    wrap: false
  }, {
    default: _withCtx(function () {
      return [_createVNode(_component_a_col, null, {
        default: _withCtx(function () {
          return [_hoisted_3];
        }),
        _: 1
      }), _createVNode(_component_a_col, {
        class: "text-right"
      }, {
        default: _withCtx(function () {
          return [!_ctx.isHideInfo ? (_openBlock(), _createBlock(_component_a_space, {
            key: 0,
            size: 16
          }, {
            default: _withCtx(function () {
              return [_ctx.userService.user && _ctx.userService.user.avatar ? (_openBlock(), _createBlock(_component_a_dropdown, {
                key: 0,
                placement: "bottomCenter"
              }, {
                overlay: _withCtx(function () {
                  return [_createVNode(_component_a_menu, null, {
                    default: _withCtx(function () {
                      return [_createVNode(_component_a_menu_item, null, {
                        default: _withCtx(function () {
                          return [_createVNode(_component_a_button, {
                            class: "btn-user-center",
                            type: "text",
                            onClick: _ctx.goToUserCenter,
                            block: ""
                          }, {
                            default: _withCtx(function () {
                              return [_hoisted_5];
                            }),
                            _: 1
                          }, 8, ["onClick"])];
                        }),
                        _: 1
                      }), _createVNode(_component_a_menu_item, null, {
                        default: _withCtx(function () {
                          return [_createVNode(_component_a_button, {
                            class: "btn-user-center",
                            type: "text",
                            onClick: _ctx.logout,
                            block: ""
                          }, {
                            default: _withCtx(function () {
                              return [_hoisted_6];
                            }),
                            _: 1
                          }, 8, ["onClick"])];
                        }),
                        _: 1
                      })];
                    }),
                    _: 1
                  })];
                }),
                default: _withCtx(function () {
                  return [_createElementVNode("div", {
                    onClick: _cache[0] || (_cache[0] =
                    //@ts-ignore
                    function () {
                      var args = [];
                      for (var _i = 0; _i < arguments.length; _i++) {
                        args[_i] = arguments[_i];
                      }
                      return _ctx.goToUserCenter && _ctx.goToUserCenter.apply(_ctx, args);
                    })
                  }, [_createVNode(_component_a_avatar, {
                    class: "avatar",
                    size: "large",
                    src: _ctx.userService.user && _ctx.userService.user.avatar,
                    alt: "avatar"
                  }, null, 8, ["src"]), _hoisted_4])];
                }),
                _: 1
              })) : (_openBlock(), _createBlock(_component_a_button, {
                key: 1,
                onClick: _ctx.loginService.showLoginDialog,
                rel: "noopener",
                type: "primary",
                shape: "round"
              }, {
                default: _withCtx(function () {
                  return [_hoisted_7];
                }),
                _: 1
              }, 8, ["onClick"])), !_ctx.hideEntryFlag ? (_openBlock(), _createBlock(_component_a_button, {
                key: 2,
                type: "text",
                href: "".concat(_ctx.domains.apiDomain, "/ug-fe-contest-score/login"),
                target: "_blank",
                style: {
                  "color": "#fff"
                }
              }, {
                default: _withCtx(function () {
                  return [_hoisted_8];
                }),
                _: 1
              }, 8, ["href"])) : _createCommentVNode("", true)];
            }),
            _: 1
          })) : _createCommentVNode("", true)];
        }),
        _: 1
      })];
    }),
    _: 1
  })]), _createVNode(_component_LoginDialog, {
    showCloseBtn: _ctx.showCloseBtn
  }, null, 8, ["showCloseBtn"]), _createVNode(_component_GoToEnvCheckDialog)]);
}